export enum RightBarActionType {
  SHOW_RIGHT_BAR = 'SHOW_RIGHT_BAR',
  HIDE_RIGHT_BAR = 'HIDE_RIGHT_BAR',
  FULL_SCREEN = 'FULL_SCREEN',
  COLLAPSE = 'COLLAPSE',
  ACTIONS_BAR = 'ACTIONS_BAR',
  SCHEDULE_BAR = 'SCHEDULE_BAR',
}
